import {Component, OnInit, input, ChangeDetectionStrategy} from "@angular/core"
import {LoadingSpinnerIconComponent} from "@app/common/components/progress/loading-spinner-icon/loading-spinner-icon.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-loading-spinner",
    templateUrl: "./loading-spinner.component.html",
    styleUrls: ["./loading-spinner.component.scss"],
    imports: [LoadingSpinnerIconComponent],
})
export class LoadingSpinnerComponent implements OnInit {
    readonly $showSpinner = input(true, {alias: "showSpinner"})

    ngOnInit(): void {}
}
